module.exports = __webpack_public_path__ + "img/icon-good-red@3x.48c57ba2.png";